export default __webpack_public_path__ + "static/media/car.4caafd8d.svg";